import { storefrontCartServicesHttpClient } from '../../../utils/HttpClient'
import { updateNewCheckoutInLocalStorage } from '../../checkoutService/newCheckoutService.helper'
import { getDataWithProductAndInventory } from '../cart.service.helper'

export const saveItemForLater = async (
  cartId: string,
  saveForLaterLineItems: {
    lineItemId: string | null | undefined
  }[],
): Promise<any> => {
  try {
    const { data } = await storefrontCartServicesHttpClient.put(`/carts/${cartId}/save-items-for-later`, {
      saveForLaterLineItems,
    })
    const cart = await getDataWithProductAndInventory(data)
    updateNewCheckoutInLocalStorage(cart)
    return cart
  } catch (e) {
    console.error('Failed while fetching saveItemForLater(), API - `/carts/${cartId}/save-items-for-later`', e)
    throw e
  }
}

export const moveItemBackToCart = async (
  cartId: string,
  moveToCartLineItems: {
    lineItemId: string | null | undefined
  }[],
): Promise<any> => {
  try {
    const { data } = await storefrontCartServicesHttpClient.put(`/carts/${cartId}/move-items-to-cart`, {
      moveToCartLineItems,
    })
    const cart = await getDataWithProductAndInventory(data)
    updateNewCheckoutInLocalStorage(cart)
    return cart
  } catch (e) {
    console.error('Failed while fetching moveItemBackToCart(), API - `/carts/${cartId}/move-items-to-cart`', e)
    throw e
  }
}
